import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 15h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 9h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 9h2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Annoyed";
const Annoyed = memo(themed(Icon));
export {
  Annoyed
};
//# sourceMappingURL=annoyed.js.map
